// AI-CONTEXT: See docs/features/arbeidsvaardigheden.md
import { EFFECTEN } from './arbeidsvaardighedenStandaard'

/**
 * Effectscores uit de antwoorden van één beoordeling.
 *
 * De score per effect is het gemiddelde van de stellingen die meetellen. Vijf van
 * de 46 tellen niet mee. Ze worden wel uitgevraagd en zijn zichtbaar voor de
 * begeleiding, maar hun positieve pool is normatief niet houdbaar - behoefte aan
 * structuur is een kenmerk, geen tekortkoming. Ze mogen ook niet indirect via een
 * gemiddelde doorwerken.
 *
 * Er wordt niets gespiegeld. Elke stelling is een tegenpolenpaar met de gunstige
 * kant links, en het antwoord is al de Likert-score (5 = linkerpool). Zolang de
 * standaard geen negatief geformuleerde stelling bevat is spiegelen overbodig; de
 * generator weigert een standaard waarin er wel een zit, juist omdat het hier
 * anders stil misgaat.
 *
 * Een onvolledig ingevuld effect levert `score: null` op, geen gemiddelde over
 * wat er toevallig wel is. Een gemiddelde over de helft van de stellingen ziet
 * eruit als een score en is er geen; `beantwoord` en `totaal` laten de voortgang
 * zien zonder dat te suggereren.
 *
 * @param {Object<string, Object<number, number>>} antwoorden - per effect-id een
 *   map van stellingnummer naar antwoord (1-5). Ontbrekende sleutels = niet
 *   beantwoord.
 * @returns {Array<{id, naam, score, beantwoord, totaal, compleet}>}
 */
const berekenEffectscores = (antwoorden = {}) =>
    EFFECTEN.map(effect => {
        const scorend = effect.stellingen.filter(s => s.teltMeeInScore)
        const perEffect = antwoorden[effect.id] || {}

        const waarden = scorend
            .map(stelling => perEffect[stelling.nummer])
            .filter(waarde => Number.isFinite(waarde))

        const compleet = waarden.length === scorend.length && scorend.length > 0

        return {
            id: effect.id,
            naam: effect.naam,
            score: compleet ? waarden.reduce((a, b) => a + b, 0) / waarden.length : null,
            beantwoord: waarden.length,
            totaal: scorend.length,
            compleet,
        }
    })

export default berekenEffectscores
